import { render, staticRenderFns } from "./Persona.vue?vue&type=template&id=3cb487f4&scoped=true"
import script from "./Persona.vue?vue&type=script&lang=js"
export * from "./Persona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb487f4",
  null
  
)

export default component.exports